const termoContraprova = () => import("./termoContraprova.vue");

const termoContraprovaRoutes = {
  name: "termoContraprova",
  meta: {
    title: "TERMO DE CONTRAPROVA",
    requiresAuth: true,
  },
  component: termoContraprova,
};

export default termoContraprovaRoutes;
